import { render, staticRenderFns } from "./ExceptionDiscount.vue?vue&type=template&id=23dd74f4"
import script from "./ExceptionDiscount.vue?vue&type=script&lang=js"
export * from "./ExceptionDiscount.vue?vue&type=script&lang=js"
import style0 from "./ExceptionDiscount.vue?vue&type=style&index=0&id=23dd74f4&prod&lang=scss"
import style1 from "./ExceptionDiscount.vue?vue&type=style&index=1&id=23dd74f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports